<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'
    import { stpOrdenStore, modalStore } from '../stores'

    import StpService from '../$services/stp.service'
    import StpMethods from '../$methods/stp.methods'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'
    import InfoTag from '../$components/info.tag.svelte'
    import Spinner from '../$components/spinner.svelte'

    let historico = []
    let loading = false

    $: statusColor = $stpOrdenStore?.status === 'pending' ? 'warning'
        : $stpOrdenStore?.status === 'error' ? 'danger'
        : 'success'

    $: $modalStore === 'stpOrden_modal' && $stpOrdenStore?.claveRastreo && $stpOrdenStore?.fechaOperacion && getHistorico($stpOrdenStore)

    async function getHistorico(orden) {

        historico = []
        loading = true
        const resp = await StpService.getHistorico({
            fechaOperacion: orden.fechaOperacion,
            claveRastreo: orden.claveRastreo,
        })
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        historico = Array.isArray(resp.data) ? resp.data.reverse() : []
    }

    function tipoOrden(tipo) {
        return { E: 'Enviada', R: 'Recibida' }[tipo] || tipo
    }

</script>

{#if $stpOrdenStore}

    <InfoCard subtitle="Orden STP" title={ $stpOrdenStore.claveRastreo }>
        <span slot="tag">
            <InfoTag color={ statusColor } label={ TranslateMethods.get($stpOrdenStore.status) } />
        </span>
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Monto" icon="fas fa-dollar-sign" value={ NumeralMethods.cash($stpOrdenStore.monto) } bold color="success" size="full" />
            <InfoField label="Referencia numérica" icon="fas fa-hashtag" value={ $stpOrdenStore.referenciaNumerica } />
            <InfoField label="Clave de rastreo" icon="fas fa-hashtag" value={ $stpOrdenStore.claveRastreo } />
            <InfoField label="Concepto" icon="fas fa-file-alt" value={ $stpOrdenStore.conceptoPago } size="full" />
            <InfoField label="Fecha de operación" icon="far fa-calendar-alt" value={ DateMethods.dateLarge(Moment(`${$stpOrdenStore.fechaOperacion}`, 'YYYYMMDD').toDate()) } />
            <InfoField label="Fecha de registro" icon="far fa-clock" value={ DateMethods.dateTimeLarge($stpOrdenStore.created) } />
            {#if $stpOrdenStore.status === 'error'}
                <InfoField label="Error" icon="fas fa-exclamation-triangle" value={ $stpOrdenStore.error } color="danger" size="full" />
            {/if}
        </div>
    </InfoCard>

    <InfoCard subtitle="Beneficiario">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Nombre" icon="fas fa-user" value={ $stpOrdenStore.nombreBeneficiario } bold />
            <InfoField label="RFC / CURP" icon="fas fa-id-card" value={ $stpOrdenStore.rfcCurpBeneficiario } />
            <InfoField label="Cuenta" icon="fas fa-university" value={ $stpOrdenStore.cuentaBeneficiario } />
            <InfoField label="Tipo de cuenta" icon="fas fa-wallet" value={ StpMethods.getTipoCuenta($stpOrdenStore.tipoCuentaBeneficiario) } />
            <InfoField label="Institución" icon="fas fa-landmark" value={ StpMethods.getInstitucion($stpOrdenStore.institucionContraparte) } size="full" />
        </div>
    </InfoCard>

    {#if $stpOrdenStore.nombreOrdenante || $stpOrdenStore.cuentaOrdenante}
        <InfoCard subtitle="Ordenante">
            <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
                {#if $stpOrdenStore.nombreOrdenante}
                    <InfoField label="Nombre" icon="fas fa-user" value={ $stpOrdenStore.nombreOrdenante } bold />
                {/if}
                {#if $stpOrdenStore.rfcCurpOrdenante}
                    <InfoField label="RFC / CURP" icon="fas fa-id-card" value={ $stpOrdenStore.rfcCurpOrdenante } />
                {/if}
                {#if $stpOrdenStore.cuentaOrdenante}
                    <InfoField label="Cuenta" icon="fas fa-university" value={ $stpOrdenStore.cuentaOrdenante } />
                {/if}
                {#if $stpOrdenStore.tipoCuentaOrdenante}
                    <InfoField label="Tipo de cuenta" icon="fas fa-wallet" value={ StpMethods.getTipoCuenta($stpOrdenStore.tipoCuentaOrdenante) } />
                {/if}
                {#if $stpOrdenStore.empresa}
                    <InfoField label="Empresa" icon="fas fa-building" value={ $stpOrdenStore.empresa } />
                {/if}
                {#if $stpOrdenStore.institucionOperante}
                    <InfoField label="Institución operante" icon="fas fa-landmark" value={ StpMethods.getInstitucion($stpOrdenStore.institucionOperante) } />
                {/if}
            </div>
        </InfoCard>
    {/if}

    {#if $stpOrdenStore.latitud && $stpOrdenStore.longitud}
        <InfoCard subtitle="Ubicación">
            <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
                <InfoField label="Google Maps" icon="fas fa-map-marker-alt" size="full">
                    <a
                        class="is-size-6"
                        href="https://www.google.com/maps?q={$stpOrdenStore.latitud},{$stpOrdenStore.longitud}"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span class="icon is-small mr-1"><i class="fas fa-external-link-alt"></i></span>
                        Ver ubicación
                    </a>
                </InfoField>
            </div>
        </InfoCard>
    {/if}

    <Spinner {loading} />

    {#each historico as item}
        <InfoCard subtitle="Histórico STP" title={ item.estado }>
            <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
                {#if item.tipoOrden}
                    <InfoField label="Tipo de orden" icon="fas fa-exchange-alt" value={ tipoOrden(item.tipoOrden) } />
                {/if}
                {#if item.tsCaptura}
                    <InfoField label="Captura" icon="far fa-clock" value={ DateMethods.dateTimeLarge(item.tsCaptura) } />
                {/if}
                {#if item.tsLiquidacion}
                    <InfoField label="Liquidación" icon="far fa-clock" value={ DateMethods.dateTimeLarge(item.tsLiquidacion) } />
                {/if}
                {#if item.rfcCep}
                    <InfoField label="RFC CEP" icon="fas fa-id-card" value={ item.rfcCep } />
                {/if}
                {#if item.nombreCep && item.nombreCep !== $stpOrdenStore.nombreBeneficiario}
                    <InfoField label="Nombre CEP" icon="fas fa-user" value={ item.nombreCep } />
                {/if}
                {#if item.claveRastreoDev}
                    <InfoField label="Clave de rastreo devolución" icon="fas fa-undo" value={ item.claveRastreoDev } />
                {/if}
                {#if item.causaDevolucion}
                    <InfoField label="Causa de devolución" icon="fas fa-exclamation-triangle" value={ item.causaDevolucion } color="danger" size="full" />
                {/if}
                {#if item.urlCEP}
                    <InfoField label="CEP Banxico" icon="fas fa-file-invoice" size="full">
                        <a
                            class="is-size-6"
                            href={ item.urlCEP }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span class="icon is-small mr-1"><i class="fas fa-external-link-alt"></i></span>
                            Ver comprobante
                        </a>
                    </InfoField>
                {/if}
            </div>
        </InfoCard>
    {/each}

{/if}
